module.exports = __webpack_public_path__ + "static/media/canam-ryker-fr-rbg-white.09dbe5d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/canam-ryker-fr-rbg-white.png
// module id = 647
// module chunks = 0